<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
    			<!-- <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"> -->
            <div class="md-layout-item md-size-40 md-small-size-66 md-xsmall-size-100 md-medium-size-50 mx-auto">
    				<h2>敬請期待我們的發表</h2>
              <h3>Spaces Go is preparing to release</h3>
              <br>              
    			</div>
        </div>
      </div>
    </parallax>    
  </div>
</template>

<script>


if(location.href=="https://www.spacesgo.com/" || location.href=="https://spacesgo.com/" || location.href=="http://www.spacesgo.com/" || location.href=="http://spacesgo.com/")
{
  location.replace("https://www.viainno.com/_Solution_SpacesGo.php");
}

export default {
  bodyClass: "profile-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/0040030-PS.jpg")
    }  
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
          //background: ` url(${this.header}) center center`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
h2{
  margin: 0 0 8px 0;
  line-height: 1em;
  text-shadow: black 0.1em 0.1em 0.2em;
}
h3{
  margin: 0 0 30px 0;
  text-shadow: black 0.1em 0.1em 0.2em;
}
</style>
